import { render, staticRenderFns } from "./phaseCheck.vue?vue&type=template&id=18c49a3a&scoped=true&"
import script from "./phaseCheck.vue?vue&type=script&lang=js&"
export * from "./phaseCheck.vue?vue&type=script&lang=js&"
import style0 from "./phaseCheck.vue?vue&type=style&index=0&id=18c49a3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c49a3a",
  null
  
)

export default component.exports